import { useQuery } from 'react-query';
import request from '../../../../helpers/request';

const key = ['transportTypes'];

const getTransportCountries = async () => {
  return await request.get(
    '/Access/types/transport',
    {},
    'При загрузке типов ТС произошла ошибка',
    []
  );
};

const useTransportTypes = (options) =>
  useQuery(key, getTransportCountries, options);

export default useTransportTypes;
